export default "__VITE_ASSET__CPnPVuwa__"